import React, { useRef, useState, useEffect } from "react";
import { Button, Col, Row } from "react-bootstrap";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { ExclamationCircle } from "react-bootstrap-icons";
import jsDig from "utils/jsDig";
import updateParams from "utils/updateParams.js";



export default function SaveChanges(props) {
  const [open, setOpen] = useState(false);
  const [showSavePrompt, setShowSavePrompt] = useState(false);
  const [showGoalWarning, setShowGoalWarning] = useState(false);
  const [targetLinkId, setTargetLinkId] = useState("");

  // let dashboardOrderOrig = "";
  // $('input[name^="[dashboard_builder]"]').each(function () {
  //   dashboardOrderOrig += $(this).is(":checked") + $(this).attr("name");
  // });

  const [dashboardOrderOrig, setDashboardOrderOrig] = useState("")
  useEffect(() => {
    $(() => {
      let dbTemp = "" ;
      $('input[name^="[dashboard_builder]"]').each(function () {
        dbTemp += $(this).is(":checked") + $(this).attr("name");
      });
     setDashboardOrderOrig(dbTemp)
    })
  }, [])
  

  const inputRef = useRef();

  // Attach click event handlers to nav links
  const navLinkSelector = ".client_config-account_config .col.nav-item a.nav-link, .client_config-seo_config .col.nav-item a.nav-link, .client_config-ppc_config .col.nav-item a.nav-link";
  useEffect(() => {
    $(() => {
      let pageHtmlOrig = $(".client-config-content").serialize().replace(/selected_page=.+?&/g, "").replace(/selected_subpage=.+?&/g, "");

      $(navLinkSelector).on("click", (e) => {
        let pageHtmlSnap = $(".client-config-content").serialize().replace(/selected_page=.+?&/g, "").replace(/selected_subpage=.+?&/g, "");
        if (pageHtmlOrig != pageHtmlSnap) {
            e.preventDefault();
            const el = $(e.target);
            setTargetLinkId(el.attr("id"))
            setShowSavePrompt(true);
            return false;
        }
      })
    });
  }, [])

  // TODO: Optimize - Couldn't figure out how to get this to change tab without reloading
  const routeToTargetLink = (key, linkType) => {
    if (linkType == "base") {
      location.href = location.origin + `/datapulse/${key}-config`
    } else {
      updateParams(linkType, key, props.page);
      location.reload()
    }
  }

  // If the user is on the goals subpage and they have not set a goal for the current year, return true
  const shouldShowGoalWarning = () => {
    let showWarning = false;
    const searchParams = new URL(location.href).searchParams;
    const page = searchParams.get("subpage");
    if (page == "goals") {
      const currentYear = new Date().getFullYear();
      const currentYearGoals = $('input[name*="[' + currentYear + ']"]:not(:hidden)');
      currentYearGoals.each((i, el) => {
        if ($(el).val() == "") {
          showWarning = true;
        }
      });
    }
    return showWarning;
  }


  const shouldStartDataPull = (dashboardOrderOrig) => {

    const values = $('input[name^="[pull_platform_data]"]').map(function () {
      if ($(this).val() == "1" && $(this).is(":checked")) return $(this).attr("name");
    }).get();

    let dashboardOrderTemp = "";
    $('input[name^="[dashboard_builder]"]').each(function () {
      dashboardOrderTemp += $(this).is(":checked") + $(this).attr("name");
    });
    if (dashboardOrderTemp !== dashboardOrderOrig) {
      if (props.seo) {
        $('input[name^="[pull_platform_data][seo]"]').map(function () {
          if ($(this).val() == "1" && $(this).attr('id') != "semrush") {
            $(`input[name^="[pull_platform_data][seo]start_date"]`).val(`${new Date().getFullYear() - 1}0101`);
            $(this).prop("checked", true);
          }
        });
      }
      if (props.ppc) {
        $('input[name^="[pull_platform_data][ppc]"]').map(function () {
          if ($(this).val() == "1") {
            $('input[name^="[pull_platform_data][ppc]start_date"]').val(`${new Date().getFullYear() - 1}0101`);
            $(this).prop("checked", true);
          }
        });
      }
      if (props.tabLocation) {
        $(`input[name^="[pull_platform_data][${props.tabLocation}]"]`).map(function () {
          if ($(this).val() == "1") {
            $(`input[name^="[pull_platform_data][${props.tabLocation}]start_date"]`).val(`${new Date().getFullYear() - 1}0101`);
            $(this).prop("checked", true);
          }
        });
      }
    }
      return (values.length > 0 || dashboardOrderTemp !== dashboardOrderOrig)
  }

  // If a user switches tabs after making changes to the page, they should be forced to choose whether they want to save or not
  const savePrompt = (
    <>
      <input type="submit" hidden ref={inputRef} />
      <Dialog open={showSavePrompt} onClose={() => setShowSavePrompt(false)} aria-labelledby="alert-dialog-title" maxWidth="md">
        <DialogTitle id="alert-dialog-title" style={{ color: "#2C345B", fontFamily: "visby-bold", fontSize: "24px" }}>
          <ExclamationCircle style={{ verticalAlign: "text-top" }} /> &nbsp; You have unsaved changes.
        </DialogTitle>
        <div onClick={() => setShowSavePrompt(false)} style={{ position: "relative", top: "-45px", textAlign: "right", right: "15px" }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" style={{ position: "relative" }}>
            <path
              fill="rgb(0,0,0)"
              fillRule="evenodd"
              d="M8 9.41421356l-4.29289322 4.29289322-1.41421356-1.41421356L6.58578644 8 2.29289322 3.70710678l1.41421356-1.41421356L8 6.58578644l4.29289322-4.29289322 1.41421356 1.41421356L9.41421356 8l4.29289322 4.29289322-1.41421356 1.41421356L8 9.41421356z"
            />
          </svg>
        </div>
        <DialogContent style={{top: "-35px", position: "relative"}}>
          <p style={{ color: "#555555", fontFamily: "nunito-regular", fontSize: "14px" }}>
            You are attempting to leave this page with unsaved changes. Would you like to save your changes first?
          </p>
        </DialogContent>
        <div className="d-flex flex-column flex-md-row justify-content-between p-4">
          <Button
            onClick={() => setShowSavePrompt(false)}
            style={{
              backgroundColor: "#a3a3a3",
              paddingTop: "8px",
              paddingBottom: "8px",
              paddingLeft: "22px",
              paddingRight: "22px",
            }}>
            Hold on, go back
          </Button>
          <Button
            style={{
              backgroundColor: "#3291c1",
              paddingTop: "8px",
              paddingBottom: "8px",
              paddingLeft: "22px",
              paddingRight: "22px"
            }}
            onClick={() => {
              const targetLink = $(`#${targetLinkId}`);
              if (targetLink) {
                const key = targetLink.data("rbEventKey");
                const linkType = targetLink.data("linkType");
                setShowSavePrompt(false)
                routeToTargetLink(key, linkType);
              }
            }}
            autoFocus>
            Discard and proceed
          </Button>
          <Button
            style={{
              backgroundColor: "#42ba96",
              paddingTop: "8px",
              paddingBottom: "8px",
              paddingLeft: "22px",
              paddingRight: "22px",
            }}
            onClick={() => {
              const targetLink = $(`#${targetLinkId}`);
              if (targetLink) {
                const key = targetLink.data("rbEventKey");
                const linkType = targetLink.data("linkType");
                setShowSavePrompt(false)
                // Add redirect directive to form after save
                let redirectUrl = "";
                if (linkType == "base") {
                  redirectUrl = location.origin + `/datapulse/${key}-config`
                } else {
                  let searchParams = new URL(location.href).searchParams;
                  searchParams.set(linkType, key);
                  redirectUrl = `${window.location.origin}${window.location.pathname}?${searchParams.toString()}`
                }
                $("<input>").attr({
                  name: "redirect_url",
                  id: "redirect_url",
                  type: "hidden",
                  value: redirectUrl
                }).appendTo("form.client-config-content");
              }
              shouldStartDataPull(dashboardOrderOrig) ? setOpen(true) :
              shouldShowGoalWarning() ? setShowGoalWarning(true) :
              inputRef.current.click();
            }}
            autoFocus>
            Save and proceed
          </Button>
        </div>
      </Dialog>
    </>
  )

  // If a user hasn't filled out goals for the current year yet, they won't be able to save
  const goalWarning = (
    <>
      <Dialog open={showGoalWarning} onClose={() => setShowGoalWarning(false)} aria-labelledby="alert-dialog-title" maxWidth="md">
        <DialogTitle id="alert-dialog-title" style={{ color: "#2C345B", fontFamily: "visby-bold", fontSize: "24px" }}>
          <ExclamationCircle style={{ verticalAlign: "text-top" }} /> &nbsp; You have empty goals.
        </DialogTitle>
        <div onClick={() => setShowGoalWarning(false)} style={{ position: "relative", top: "-45px", textAlign: "right", right: "15px" }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" style={{ position: "relative" }}>
            <path
              fill="rgb(0,0,0)"
              fillRule="evenodd"
              d="M8 9.41421356l-4.29289322 4.29289322-1.41421356-1.41421356L6.58578644 8 2.29289322 3.70710678l1.41421356-1.41421356L8 6.58578644l4.29289322-4.29289322 1.41421356 1.41421356L9.41421356 8l4.29289322 4.29289322-1.41421356 1.41421356L8 9.41421356z"
            />
          </svg>
        </div>
        <DialogContent style={{top: "-35px", position: "relative"}}>
          <p style={{ color: "#555555", fontFamily: "nunito-regular", fontSize: "14px" }}>
            You must finish entering goals for the current year before you can save.
          </p>
        </DialogContent>
        <div className="d-flex flex-column flex-md-row justify-content-between p-4">
          <Button
            onClick={() => setShowGoalWarning(false)}
            style={{
              backgroundColor: "#3291c1",
              paddingTop: "8px",
              paddingBottom: "8px",
              paddingLeft: "22px",
              paddingRight: "22px",
            }}>
            Ok I will fill them out
          </Button>
        </div>
      </Dialog>
    </>
  )

  const dataPullSave = (
    <>
      <input type="submit" hidden ref={inputRef} />
      <Dialog open={open} onClose={() => setOpen(false)} aria-labelledby="alert-dialog-title">
        <DialogTitle id="alert-dialog-title" style={{ color: "#2C345B", fontFamily: "visby-bold", fontSize: "24px" }}>
          <ExclamationCircle style={{ verticalAlign: "text-top" }} /> &nbsp; Important: Initiating Data Pull
        </DialogTitle>
        <div onClick={() => setOpen(false)} style={{ position: "absolute", right: "5px", cursor: "pointer" }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" style={{ position: "relative" }}>
            <path
              fill="rgb(0,0,0)"
              fillRule="evenodd"
              d="M8 9.41421356l-4.29289322 4.29289322-1.41421356-1.41421356L6.58578644 8 2.29289322 3.70710678l1.41421356-1.41421356L8 6.58578644l4.29289322-4.29289322 1.41421356 1.41421356L9.41421356 8l4.29289322 4.29289322-1.41421356 1.41421356L8 9.41421356z"
            />
          </svg>
        </div>
        <DialogContent style={{position: "relative"}}>
          <p style={{ color: "#555555", fontFamily: "nunito-regular", fontSize: "14px" }}>
            You have requested to initiate a data pull, or changes made on this page would require a data pull to proceed.
          </p>
          <p style={{ color: "#2C345B", fontFamily: "nunito-bold", fontSize: "14px" }}>
            A data pull can take up to several hours and you will not be able to access or make changes to this account's associated configuration pages until
            the pull is finished. Please proceed with full certainty!
          </p>
        </DialogContent>
        <div className="d-flex flex-column mx-auto justify-content-between p-4">
          <Button
            onClick={() => setOpen(false)}
            style={{
              backgroundColor: "#3291c1",
              paddingTop: "8px",
              paddingBottom: "8px",
              paddingLeft: "22px",
              paddingRight: "22px",
              marginBottom: "10px"
            }}>
            Hold on, go back
          </Button>
          <Button
            style={{
              backgroundColor: "#42ba96",
              paddingTop: "8px",
              paddingBottom: "8px",
              paddingLeft: "22px",
              paddingRight: "22px",
              marginBottom: "10px"
            }}
            onClick={() => inputRef.current.click()}
            autoFocus>
            Save changes and initiate data pull
          </Button>
          {
          props.userIsAdmin &&
            <button class="snp"
            onClick={() => {
              const targetLink = $(`#${targetLinkId}`);
              if (targetLink) {
                const key = targetLink.data("rbEventKey");
                const linkType = targetLink.data("linkType");
                setShowSavePrompt(false)
                // Add redirect directive to form after save
                let redirectUrl = "";
                if (linkType == "base") {
                  redirectUrl = location.origin + `/datapulse/${key}-config`
                } else {
                  let searchParams = new URL(location.href).searchParams;
                  searchParams.set(linkType, key);
                  redirectUrl = `${window.location.origin}${window.location.pathname}?${searchParams.toString()}`
                }
                
                $("<input>").attr({
                  name: "redirect_url",
                  id: "redirect_url",
                  type: "hidden",
                  value: redirectUrl
                }).appendTo("form.client-config-content");
              }

              inputRef.current.click();
            }}
            autoFocus>
            Save without Pull
          </button>
        }
        </div>
      </Dialog>
    </>
  );

  return (
    <Row>
      <Col className={props.onboarding ? "text-center text-sm-left" : "center-from-right"}>
        {props.onboarding ? (
          <Button
            style={{
              backgroundColor: "#3291C1",
              paddingTop: "8px",
              paddingBottom: "8px",
              paddingLeft: "22px",
              paddingRight: "22px",
            }}
            className="ml-sm-3 mr-sm-5 mx-0"
            as="input"
            type="submit"
            value="Save and come back later"
            variant="success"
            onClick={props.onClick}
            id="onboardingSaveBtn"
          />
        ) : (
          <Button
            style={{
              marginTop: "32px",
              marginBottom: "30px",
              paddingTop: "9px",
              paddingBot: "9px",
              paddingRight: "35px",
              paddingLeft: "35px",
            }}
            className=" ml-3 mr-3 mr-md-5"
            as="input"
            type="button"
            value="Save changes"
            variant="success"
            id="main-save-btn"
            onClick={
              props.onClick
              ? props.onClick
              : () => {
                shouldStartDataPull(dashboardOrderOrig) ? setOpen(true) :
                shouldShowGoalWarning() ? setShowGoalWarning(true) :
                inputRef.current.click();
              }
            }
            />
        )}
        {props.userIsAdmin &&
          <Button
          style={{
            marginTop: "32px",
            marginBottom: "30px",
          }}
          className=" ml-3 mr-3 mr-md-5 snp"
          as="input"
          type="button"
          value="Save without pulling"
          variant="success"
          id="main-save-btn"
          onClick={() => {
            inputRef.current.click()}
          }
          />
        }
        {dataPullSave}
        {savePrompt}
        {goalWarning}
      </Col>
    </Row>
  );
}
